export class BaseModel {
  [key: PropertyKey]: any;
}
